"use client";

import { Menu, X } from "lucide-react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { navItems } from "@/lib/shared/constants";
import { useDisclosure } from "@/lib/shared/hooks";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/ui";
import { preventCurrentRouteNavigation, RouteLoadingLinkStatus } from "./RouteLoadingSpinner";

/**
 * MobileDropdownNav component - Mobile dropdown navigation menu
 */
export const MobileDropdownNav = () => {
  const { isOpen, toggle } = useDisclosure();
  const t = useTranslations("navigation");

  return (
    <DropdownMenu
      open={isOpen}
      onOpenChange={(open: boolean) => toggle(open)}
    >
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="pl-1"
          data-testid="mobile-nav-menu-trigger"
        >
          {isOpen ? <X className="h-8 w-8" /> : <Menu className="h-8 w-8" />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="z-50 w-40">
        <DropdownMenuGroup>
          {navItems.map((item) => {
            if (item.subItems) {
              return (
                <DropdownMenuSub key={item.name}>
                  <DropdownMenuSubTrigger className="w-full">{t(item.name)}</DropdownMenuSubTrigger>
                  <DropdownMenuPortal>
                    <DropdownMenuSubContent>
                      {item.subItems.map((subItem) => (
                        <DropdownMenuItem
                          asChild
                          key={subItem.name}
                        >
                          <Link
                            href={subItem.href ?? "/public"}
                            onClickCapture={preventCurrentRouteNavigation}
                          >
                            {t(subItem.name)}
                            <RouteLoadingLinkStatus />
                          </Link>
                        </DropdownMenuItem>
                      ))}
                    </DropdownMenuSubContent>
                  </DropdownMenuPortal>
                </DropdownMenuSub>
              );
            }
            return (
              <DropdownMenuItem
                asChild
                key={item.name}
              >
                <Link
                  href={item.href ?? "/public"}
                  onClickCapture={preventCurrentRouteNavigation}
                >
                  {t(item.name)}
                  <RouteLoadingLinkStatus />
                </Link>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
